import { compareValueWithPrefix, extractParts } from '@/helpers/compareValueWithPrefix'

export const sortRoutes = (routes: string[], defaultRoutes: string[] = []): string[] => {
    if (!defaultRoutes.length) {
        return routes.sort(routeSorter)
    }

    const restRoutes = routes.filter((route) => !defaultRoutes.includes(route))

    return [...defaultRoutes.sort(routeSorter), ...restRoutes.sort(routeSorter)]
}

export const routeSorter = (routeA: string, routeB: string): number => {
    const [prefixA, numA, suffixA] = extractParts(routeA)
    const [prefixB, numB, suffixB] = extractParts(routeB)

    return compareValueWithPrefix([prefixA, numA, suffixA], [prefixB, numB, suffixB])
}
